<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { useComponentComposable } from '@/components/useComponentComposable';
import CheckBoxRule from '@/components/seasonal/CheckBoxRules.vue';
import DropdownDate from '@/components/seasonal/DropdownDate.vue';

interface Props {
  seasonalData: object;
  seasonType: string;
  adjustData: object;
  ruleChecked: object;
  seasonRule: Array<any>;
  seasonIndex: number;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:ruleChecked': [value: any] }>();

const currentLanguage = getCurrentLocale();
const { renderListMonth } = useComponentComposable();
const monthNames = renderListMonth(currentLanguage);

const ruleCheck = computed({
  get() {
    return props.ruleChecked;
  },
  set(value) {
    emits('update:ruleChecked', value);
  }
});
const monthData = ref<any>([]);

const renderMonthData = (monthNames: string[]) => {
  return monthNames.map((month: string, index) => {
    return {
      name: month,
      key: `${index + 1}`
    };
  });
};

onBeforeMount(() => {
  monthData.value = renderMonthData(monthNames);
});
</script>

<template>
  <div class="season-rules">
    <div class="flex flex-wrap flex-column justify-content-center season-rules">
      <div class="flex justify-content-between">
        <DropdownDate class="col-12 md:col-6" :dateType="'start'" :seasonObject="seasonalData" :listMonth="monthData"></DropdownDate>
        <DropdownDate class="col-12 md:col-6" :dateType="'end'" :seasonObject="seasonalData" :listMonth="monthData"></DropdownDate>
      </div>
      <CheckBoxRule v-model:ruleChecked="ruleCheck" :seasonIndex="seasonIndex" :seasonRules="seasonRule" :seasonObject="seasonalData"></CheckBoxRule>
    </div>
  </div>
</template>
